import { Icon } from "../icons/icon";
import { Button, ButtonVariations } from "./button";

export const WebsiteButton = ({
  text,
  to,
  className,
  variation = "primary",
}: {
  text: string;
  to: string;
  className?: string;
  variation?: ButtonVariations;
}) => {
  return (
    <Button
      text={text}
      onClick={() => {
        window.location.href = to;
      }}
      className={`${className} !rounded-[40px]`}
      variation={variation}
      loading={false}
      disabled={false}
      extra={
        <Icon
          svg="left-arrow"
          width={21}
          height={20}
          className={"rotate-180"}
        />
      }
    />
  );
};
